/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import {
  RecordingsStatusService,
  type TRecordingsStatusDetails
} from "@tivocorp/data-domain-lib";

import type { IRecordingsStatusInteractor } from "../../interfaces";
import type { TNetworkOptions } from "../../types";
import { Log } from "../../logging";
import { ApplicationFeatureArea } from "../../enums";
import { TIVO_SERVICES } from "../../../config";
import { BaseInteractor } from "../base";

/**
 * Facade for recording related operations, providing a clean API for consumers.
 */
export class RecordingsStatusInteractor
  extends BaseInteractor
  implements IRecordingsStatusInteractor
{
  private static readonly TAG: string = "RecordingsStatusInteractor";

  public async fetchRecordingStatus(
    options?: TNetworkOptions
  ): Promise<TRecordingsStatusDetails> {
    return this.executeGuarded(
      "fetchRecordingStatus",
      async (guardedSignal: AbortSignal): Promise<TRecordingsStatusDetails> => {
        Log.d(RecordingsStatusInteractor.TAG, "fetchRecordingStatus() called");
        const params = await this.buildServicesParams(
          TIVO_SERVICES.RecordingsStatusService,
          ApplicationFeatureArea.GUIDE
        );
        const service: RecordingsStatusService = new RecordingsStatusService(
          params
        );
        return service.getRecordingsStatusDetails(guardedSignal);
      },
      options
    );
  }
}
